import type { ZodObject, ZodRawShape } from 'zod';

import { getNestedSchema } from './getNestedSchema';


export const getRequiredGenerator = (zodSchema: ZodObject<ZodRawShape>) => (path: string): boolean => {
	const schema = getNestedSchema(zodSchema, path);

	// console.debug('getRequired', path, schema, schema?.isOptional(), schema?.isNullable());

	return schema ? !schema.isOptional() : false;
};
